module.exports = "/images/icon-map-inactive.svg?922b6075c821078f5fb599b421e7a671";